import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchTableConfig, type IFetchTableConfigParams } from '../../api/fetchers/tableConfig/fetcher';

interface FetchTableConfigActionParams extends IFetchTableConfigParams {
  essential: boolean;
}

export const fetchTableConfigAction = createAsyncThunk(
  'tableConfig/fetchTableConfig',
  (params: FetchTableConfigActionParams) => fetchTableConfig(params)
);
